/* CAF UTM attribution persistence:
 * - Captures first-touch + last-touch UTM/click IDs
 * - Persists to localStorage/cookie
 * - Syncs into Shopify cart attributes so attribution survives checkout
 */
(function () {
  'use strict';

  if (window.__cafUtmAttributionInitialized) return;
  window.__cafUtmAttributionInitialized = true;

  var STORAGE_KEY = 'caf_utm_attribution_v1';
  var COOKIE_KEY = 'caf_utm_attribution_v1';
  var CART_SYNC_KEY = 'caf_utm_cart_sync_sig_v3';
  var CART_NONEMPTY_KEYS_KEY = 'caf_utm_cart_nonempty_keys_v1';
  var BOT_BLOCKER_CONSENT_KEY = 'bot-blocker:consent';
  var FIRST_TOUCH_DAYS = 90;
  var LAST_TOUCH_DAYS = 30;
  var COOKIE_DAYS = FIRST_TOUCH_DAYS;
  var MAX_ATTR_LENGTH = 255;
  var cartSyncPendingSignature = '';
  var klaviyoUtmIdentifySent = false;
  var lastBotBlockerConsent = '';

  var PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'gclid',
    'fbclid',
    'msclkid',
    'ttclid',
    'twclid',
    'li_fat_id',
    'wbraid',
    'gbraid',
    'dclid',
    'gad_source',
    'gad_campaignid',
    'srsltid',
    'rdt_cid',
    'scclid',
    'epik',
    'cto_bundle',
    'cto_pld',
    'ref'
  ];

  var PARAM_TO_KEY = {
    utm_source: 'source',
    utm_medium: 'medium',
    utm_campaign: 'campaign',
    utm_term: 'term',
    utm_content: 'content',
    utm_id: 'id',
    gclid: 'gclid',
    fbclid: 'fbclid',
    msclkid: 'msclkid',
    ttclid: 'ttclid',
    twclid: 'twclid',
    li_fat_id: 'li_fat_id',
    wbraid: 'wbraid',
    gbraid: 'gbraid',
    dclid: 'dclid',
    gad_source: 'gad_source',
    gad_campaignid: 'gad_campaignid',
    srsltid: 'srsltid',
    rdt_cid: 'rdt_cid',
    scclid: 'scclid',
    epik: 'epik',
    cto_bundle: 'cto_bundle',
    cto_pld: 'cto_pld',
    ref: 'ref'
  };

  var CLICK_ID_SOURCE_HINTS = [
    { key: 'gclid', source: 'google', medium: 'cpc' },
    { key: 'wbraid', source: 'google', medium: 'cpc' },
    { key: 'gbraid', source: 'google', medium: 'cpc' },
    { key: 'dclid', source: 'google', medium: 'cpc' },
    { key: 'gad_source', source: 'google', medium: 'cpc' },
    { key: 'gad_campaignid', source: 'google', medium: 'cpc' },
    { key: 'msclkid', source: 'bing', medium: 'cpc' },
    { key: 'fbclid', source: 'facebook', medium: 'social' },
    { key: 'ttclid', source: 'tiktok', medium: 'social' },
    { key: 'twclid', source: 'twitter', medium: 'social' },
    { key: 'li_fat_id', source: 'linkedin', medium: 'social' },
    { key: 'rdt_cid', source: 'reddit', medium: 'social' },
    { key: 'scclid', source: 'snapchat', medium: 'social' },
    { key: 'epik', source: 'pinterest', medium: 'social' },
    { key: 'cto_bundle', source: 'criteo', medium: 'display' },
    { key: 'cto_pld', source: 'criteo', medium: 'display' }
  ];

  function safeJsonParse(value) {
    if (!value || typeof value !== 'string') return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function trimTo(value, maxLength) {
    if (value == null) return '';
    var text = String(value).trim();
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength);
  }

  function getCookie(name) {
    var cookieName = name + '=';
    var decoded = decodeURIComponent(document.cookie || '');
    var parts = decoded.split(';');
    for (var i = 0; i < parts.length; i += 1) {
      var item = parts[i].trim();
      if (item.indexOf(cookieName) === 0) {
        return item.substring(cookieName.length);
      }
    }
    return '';
  }

  function isPageAllowed() {
    if (!window.CAFBotBlockerGate || typeof window.CAFBotBlockerGate.isPageAllowed !== 'function') return true;
    return window.CAFBotBlockerGate.isPageAllowed();
  }

  function isTrackingAllowed() {
    if (!window.CAFBotBlockerGate || typeof window.CAFBotBlockerGate.isTrackingAllowed !== 'function') return true;
    return window.CAFBotBlockerGate.isTrackingAllowed();
  }

  function runWhenPageAllowed(callback) {
    if (!window.CAFBotBlockerGate || typeof window.CAFBotBlockerGate.runWhenPageAllowed !== 'function') {
      callback();
      return;
    }

    window.CAFBotBlockerGate.runWhenPageAllowed(callback);
  }

  function runWhenTrackingAllowed(callback) {
    if (!window.CAFBotBlockerGate || typeof window.CAFBotBlockerGate.runWhenTrackingAllowed !== 'function') {
      callback();
      return;
    }

    window.CAFBotBlockerGate.runWhenTrackingAllowed(callback);
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (typeof days === 'number') {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Ignore storage errors in private mode/quota limits.
    }
  }

  function readCartNonEmptyKeys() {
    var parsed = safeJsonParse(readStorage(CART_NONEMPTY_KEYS_KEY));
    if (!Array.isArray(parsed)) return [];

    var keys = [];
    for (var i = 0; i < parsed.length; i += 1) {
      if (typeof parsed[i] === 'string' && parsed[i]) keys.push(parsed[i]);
    }
    return keys;
  }

  function writeCartNonEmptyKeys(keys) {
    try {
      writeStorage(CART_NONEMPTY_KEYS_KEY, JSON.stringify(keys || []));
    } catch (_error) {
      // Ignore storage serialization errors.
    }
  }

  function getNonEmptyAttributeKeys(attributes) {
    var out = [];
    if (!attributes) return out;

    var keys = Object.keys(attributes);
    for (var i = 0; i < keys.length; i += 1) {
      var value = attributes[keys[i]];
      if (value == null) continue;
      if (String(value) !== '') out.push(keys[i]);
    }
    return out;
  }

  function keySet(keys) {
    var set = Object.create(null);
    for (var i = 0; i < keys.length; i += 1) {
      set[keys[i]] = true;
    }
    return set;
  }

  function parseQueryParams() {
    var result = {};
    var search = window.location.search || '';
    if (!search) return result;

    var query = new URLSearchParams(search);
    for (var i = 0; i < PARAMS.length; i += 1) {
      var rawKey = PARAMS[i];
      var value = query.get(rawKey);
      if (!value) continue;
      var normalizedKey = PARAM_TO_KEY[rawKey];
      result[normalizedKey] = trimTo(value, 500);
    }
    return result;
  }

  function inferSourceFromClickIds(values) {
    if (!values || typeof values !== 'object') return values;
    if (values.source && values.medium) return values;

    for (var i = 0; i < CLICK_ID_SOURCE_HINTS.length; i += 1) {
      var hint = CLICK_ID_SOURCE_HINTS[i];
      if (!values[hint.key]) continue;

      var enriched = {};
      var keys = Object.keys(values);
      for (var k = 0; k < keys.length; k += 1) {
        enriched[keys[k]] = values[keys[k]];
      }

      // Internal attribution only: do not rewrite the URL or send manual
      // campaign params to GA. The raw click IDs remain the source of truth
      // for ad platforms, while cart attributes stay readable in Shopify.
      if (!enriched.source) enriched.source = hint.source;
      if (!enriched.medium) enriched.medium = hint.medium;
      return enriched;
    }

    return values;
  }

  function hasAttributionData(values) {
    if (!values || typeof values !== 'object') return false;
    var keys = Object.keys(values);
    for (var i = 0; i < keys.length; i += 1) {
      if (values[keys[i]]) return true;
    }
    return false;
  }

  function getReferrerHost() {
    if (!document.referrer) return '';
    try {
      return new URL(document.referrer).hostname || '';
    } catch (error) {
      return '';
    }
  }

  function createTouch(params) {
    return {
      params: params,
      page_path: window.location.pathname || '/',
      page_url: window.location.origin + window.location.pathname + window.location.search,
      referrer_host: getReferrerHost(),
      captured_at: new Date().toISOString()
    };
  }

  function isTouchFresh(touch, days) {
    if (!touch || !touch.captured_at) return false;
    var capturedAt = Date.parse(touch.captured_at);
    if (!isFinite(capturedAt)) return false;
    return Date.now() - capturedAt <= days * 24 * 60 * 60 * 1000;
  }

  function normalizeAttributionPayload(payload) {
    if (!payload || typeof payload !== 'object') return null;

    if (!isTouchFresh(payload.first_touch, FIRST_TOUCH_DAYS)) {
      delete payload.first_touch;
    }
    if (!isTouchFresh(payload.last_touch, LAST_TOUCH_DAYS)) {
      delete payload.last_touch;
    }

    return payload.first_touch || payload.last_touch ? payload : null;
  }

  function readAttributionPayload() {
    var localValue = readStorage(STORAGE_KEY);
    var parsedLocal = safeJsonParse(localValue);
    if (parsedLocal) return normalizeAttributionPayload(parsedLocal);

    var cookieValue = getCookie(COOKIE_KEY);
    return normalizeAttributionPayload(safeJsonParse(cookieValue));
  }

  function writeAttributionPayload(payload) {
    if (!payload) return;
    var serialized = JSON.stringify(payload);
    writeStorage(STORAGE_KEY, serialized);
    setCookie(COOKIE_KEY, serialized, COOKIE_DAYS);
  }

  var REFERRER_SOURCE_MAP = {
    'google': { source: 'google', medium: 'organic' },
    'facebook': { source: 'facebook', medium: 'organic' },
    'bing': { source: 'bing', medium: 'organic' },
    'instagram': { source: 'instagram', medium: 'organic' },
    'pinterest': { source: 'pinterest', medium: 'organic' },
    'youtube': { source: 'youtube', medium: 'organic' },
    'tiktok': { source: 'tiktok', medium: 'organic' }
  };

  function inferSourceFromReferrer() {
    var host = getReferrerHost();
    if (!host) return null;
    var lowerHost = host.toLowerCase();

    var keys = Object.keys(REFERRER_SOURCE_MAP);
    for (var i = 0; i < keys.length; i += 1) {
      if (lowerHost.indexOf(keys[i]) !== -1) {
        return { source: REFERRER_SOURCE_MAP[keys[i]].source, medium: REFERRER_SOURCE_MAP[keys[i]].medium };
      }
    }

    // External referrer that doesn't match known sources
    if (lowerHost.indexOf(window.location.hostname) === -1) {
      return { source: host, medium: 'referral' };
    }

    return null;
  }

  function updateAttributionFromUrl(currentPayload, queryParams) {
    var payload = currentPayload && typeof currentPayload === 'object' ? currentPayload : {};
    if (!payload.version) payload.version = 1;

    var hasUtm = hasAttributionData(queryParams);
    var paramsToUse = queryParams;

    // When no UTM params, try to infer source from referrer
    if (!hasUtm) {
      var inferred = inferSourceFromReferrer();
      if (inferred) {
        paramsToUse = inferred;
        hasUtm = true;
      }
    }

    if (!hasUtm) {
      if (payload.first_touch || payload.last_touch) return payload;
      return null;
    }

    var touch = createTouch(inferSourceFromClickIds(paramsToUse));
    payload.last_touch = touch;
    payload.updated_at = touch.captured_at;

    if (!payload.first_touch || !payload.first_touch.params || !hasAttributionData(payload.first_touch.params)) {
      payload.first_touch = touch;
    }

    return payload;
  }

  function toCartAttributes(payload) {
    if (!payload || typeof payload !== 'object') return {};

    var firstTouch = payload.first_touch || {};
    var lastTouch = payload.last_touch || {};
    var firstParams = firstTouch.params || {};
    var lastParams = lastTouch.params || {};

    var attributes = {
      utm_ft_source: firstParams.source || '',
      utm_ft_medium: firstParams.medium || '',
      utm_ft_campaign: firstParams.campaign || '',
      utm_ft_term: firstParams.term || '',
      utm_ft_content: firstParams.content || '',
      utm_ft_id: firstParams.id || '',
      utm_ft_gclid: firstParams.gclid || '',
      utm_ft_fbclid: firstParams.fbclid || '',
      utm_ft_msclkid: firstParams.msclkid || '',
      utm_ft_ttclid: firstParams.ttclid || '',
      utm_ft_twclid: firstParams.twclid || '',
      utm_ft_li_fat_id: firstParams.li_fat_id || '',
      utm_ft_wbraid: firstParams.wbraid || '',
      utm_ft_gbraid: firstParams.gbraid || '',
      utm_ft_dclid: firstParams.dclid || '',
      utm_ft_gad_source: firstParams.gad_source || '',
      utm_ft_gad_campaignid: firstParams.gad_campaignid || '',
      utm_ft_srsltid: firstParams.srsltid || '',
      utm_ft_rdt_cid: firstParams.rdt_cid || '',
      utm_ft_scclid: firstParams.scclid || '',
      utm_ft_epik: firstParams.epik || '',
      utm_ft_cto_bundle: firstParams.cto_bundle || '',
      utm_ft_cto_pld: firstParams.cto_pld || '',
      utm_ft_ref: firstParams.ref || '',
      utm_ft_referrer_host: firstTouch.referrer_host || '',
      utm_ft_page: firstTouch.page_path || '',
      utm_ft_at: firstTouch.captured_at || '',

      utm_lt_source: lastParams.source || '',
      utm_lt_medium: lastParams.medium || '',
      utm_lt_campaign: lastParams.campaign || '',
      utm_lt_term: lastParams.term || '',
      utm_lt_content: lastParams.content || '',
      utm_lt_id: lastParams.id || '',
      utm_lt_gclid: lastParams.gclid || '',
      utm_lt_fbclid: lastParams.fbclid || '',
      utm_lt_msclkid: lastParams.msclkid || '',
      utm_lt_ttclid: lastParams.ttclid || '',
      utm_lt_twclid: lastParams.twclid || '',
      utm_lt_li_fat_id: lastParams.li_fat_id || '',
      utm_lt_wbraid: lastParams.wbraid || '',
      utm_lt_gbraid: lastParams.gbraid || '',
      utm_lt_dclid: lastParams.dclid || '',
      utm_lt_gad_source: lastParams.gad_source || '',
      utm_lt_gad_campaignid: lastParams.gad_campaignid || '',
      utm_lt_srsltid: lastParams.srsltid || '',
      utm_lt_rdt_cid: lastParams.rdt_cid || '',
      utm_lt_scclid: lastParams.scclid || '',
      utm_lt_epik: lastParams.epik || '',
      utm_lt_cto_bundle: lastParams.cto_bundle || '',
      utm_lt_cto_pld: lastParams.cto_pld || '',
      utm_lt_ref: lastParams.ref || '',
      utm_lt_referrer_host: lastTouch.referrer_host || '',
      utm_lt_page: lastTouch.page_path || '',
      utm_lt_at: lastTouch.captured_at || ''
    };

    var keys = Object.keys(attributes);
    for (var i = 0; i < keys.length; i += 1) {
      attributes[keys[i]] = trimTo(attributes[keys[i]], MAX_ATTR_LENGTH);
    }

    return attributes;
  }

  function getShopifySessionToken() {
    return getCookie('_shopify_s') || '';
  }

  function readBotBlockerConsent() {
    var value = readStorage(BOT_BLOCKER_CONSENT_KEY);
    return value === 'denied' || value === 'granted' ? value : '';
  }

  lastBotBlockerConsent = readBotBlockerConsent();

  function canReadPlatformCookies() {
    if (readBotBlockerConsent() === 'denied') return false;

    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;

    try {
      if (typeof privacy.userCanBeTracked === 'function') return privacy.userCanBeTracked();
      if (typeof privacy.analyticsProcessingAllowed === 'function') return privacy.analyticsProcessingAllowed();
      if (typeof privacy.marketingAllowed === 'function') return privacy.marketingAllowed();
    } catch (_error) {
      return false;
    }

    return true;
  }

  function readPlatformCookieAttributes() {
    // Capture vendor browser identifiers so server-side CAPI / Measurement
    // Protocol can stitch events back to the browser session that created
    // the cart. Names match the cookies set by Meta Pixel + Google tag.
    //   _fbp  : Meta Pixel browser ID (set on init).
    //   _fbc  : Meta Pixel click ID (set when fbclid is in URL).
    //   _ga   : GA4 client ID cookie.
    //   _gcl_au: Google Ads conversion linker.
    // Criteo identifies via cto_bundle/cto_pld query params (already in
    // PARAMS), no first-party pass-through cookie needed.
    if (!canReadPlatformCookies()) {
      return {
        caf_fbp: '',
        caf_fbc: '',
        caf_ga: '',
        caf_gcl_au: '',
      };
    }

    return {
      caf_fbp: trimTo(getCookie('_fbp'), MAX_ATTR_LENGTH),
      caf_fbc: trimTo(getCookie('_fbc'), MAX_ATTR_LENGTH),
      caf_ga: trimTo(getCookie('_ga'), MAX_ATTR_LENGTH),
      caf_gcl_au: trimTo(getCookie('_gcl_au'), MAX_ATTR_LENGTH),
    };
  }

  function buildAttributes() {
    var stored = readAttributionPayload();
    var attrs = toCartAttributes(stored);
    var platform = readPlatformCookieAttributes();
    var keys = Object.keys(platform);
    for (var i = 0; i < keys.length; i += 1) {
      attrs[keys[i]] = platform[keys[i]];
    }
    return attrs;
  }

  function pushKlaviyoUtmIdentify(payload) {
    // Push UTM as Klaviyo customer properties so flows can segment by
    // first/last touch source. Property names are CAF-prefixed to avoid
    // colliding with any standard Klaviyo property; properties stay queued
    // until Klaviyo identifies the visitor (via onsite form submit, etc.)
    // and then merge into the profile.
    if (klaviyoUtmIdentifySent) return true;
    if (!payload) return false;

    var firstTouch = payload.first_touch || {};
    var lastTouch = payload.last_touch || {};
    var ft = firstTouch.params || {};
    var lt = lastTouch.params || {};
    var props = {};

    if (ft.source) props['CAF First Touch Source'] = ft.source;
    if (ft.medium) props['CAF First Touch Medium'] = ft.medium;
    if (ft.campaign) props['CAF First Touch Campaign'] = ft.campaign;
    if (ft.term) props['CAF First Touch Term'] = ft.term;
    if (ft.content) props['CAF First Touch Content'] = ft.content;
    if (firstTouch.referrer_host) props['CAF First Touch Referrer'] = firstTouch.referrer_host;
    if (firstTouch.captured_at) props['CAF First Touch Date'] = firstTouch.captured_at;

    if (lt.source) props['CAF Last Touch Source'] = lt.source;
    if (lt.medium) props['CAF Last Touch Medium'] = lt.medium;
    if (lt.campaign) props['CAF Last Touch Campaign'] = lt.campaign;
    if (lt.term) props['CAF Last Touch Term'] = lt.term;
    if (lt.content) props['CAF Last Touch Content'] = lt.content;
    if (lastTouch.referrer_host) props['CAF Last Touch Referrer'] = lastTouch.referrer_host;
    if (lastTouch.captured_at) props['CAF Last Touch Date'] = lastTouch.captured_at;

    if (!Object.keys(props).length) return false;

    var queue = null;
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      queue = window.klaviyo;
    } else if (window._learnq && typeof window._learnq.push === 'function') {
      queue = window._learnq;
    }
    if (!queue) return false;

    try {
      queue.push(['identify', props]);
      klaviyoUtmIdentifySent = true;
      return true;
    } catch (_error) {
      // Ignore Klaviyo queue errors.
      return false;
    }
  }

  function scheduleKlaviyoUtmIdentify(payload) {
    if (!payload) return;
    if (pushKlaviyoUtmIdentify(payload)) return;

    var retry = function () {
      pushKlaviyoUtmIdentify(payload);
    };

    document.addEventListener('klaviyoOnsiteAdded', retry, { once: true });
    window.setTimeout(retry, 1500);
    window.setTimeout(retry, 5000);
  }

  function makeSignature(attributes) {
    try {
      return JSON.stringify({
        attributes: attributes,
        shopify_session: getShopifySessionToken()
      });
    } catch (error) {
      return '';
    }
  }

  function syncCartAttributes(attributes, options) {
    if (!attributes || !Object.keys(attributes).length) return;
    // Require an explicit page allow decision before writing attribution to the
    // cart. A suppress-only decision still allows first-party attribution, but
    // pending/block decisions do not write cart attributes.
    if (!isPageAllowed()) return;

    var signature = makeSignature(attributes);
    if (!signature) return;

    var shouldForce = Boolean(options && options.force);
    var previousSignature = readStorage(CART_SYNC_KEY);
    if (cartSyncPendingSignature === signature) return;
    if (!shouldForce && previousSignature === signature) return;

    var payload = new URLSearchParams();
    var keys = Object.keys(attributes);
    var currentNonEmptyKeys = getNonEmptyAttributeKeys(attributes);
    var previousNonEmptySet = keySet(readCartNonEmptyKeys());
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = attributes[key];
      if (value == null) continue;
      if (String(value) === '' && !previousNonEmptySet[key]) continue;
      payload.append('attributes[' + key + ']', String(value));
    }

    if (!payload.toString()) return;

    cartSyncPendingSignature = signature;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: payload.toString(),
      keepalive: true
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to sync cart attributes');
        writeStorage(CART_SYNC_KEY, signature);
        writeCartNonEmptyKeys(currentNonEmptyKeys);
        if (cartSyncPendingSignature === signature) cartSyncPendingSignature = '';
      })
      .catch(function () {
        if (cartSyncPendingSignature === signature) cartSyncPendingSignature = '';
        // Ignore network failures; hidden-input fallback still applies on form submit.
      });
  }

  function syncFreshCartAttributes(options) {
    if (!isPageAllowed()) return;
    syncCartAttributes(buildAttributes(), options);
  }

  function upsertHiddenInput(form, name, value) {
    if (value == null) return;
    var selector = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function injectAttributesIntoForm(form, attributes) {
    if (!form || !attributes) return;
    var keys = Object.keys(attributes);
    var previousNonEmptySet = keySet(readCartNonEmptyKeys());
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = attributes[key];
      if (value == null) continue;
      if (String(value) === '' && !previousNonEmptySet[key]) continue;
      upsertHiddenInput(form, 'attributes[' + key + ']', value);
    }
  }

  function bindCartLifecycleSync() {
    // Belt-and-suspenders re-sync at moments where an allowed session is about to
    // commit / navigate. Each call is cheap because syncCartAttributes
    // signature-dedups: when nothing changed it short-circuits before
    // hitting the network. Where it does fire, it catches the cases the
    // init+deferred path can miss:
    //   - User adds to cart after Bot Blocker has allowed the session →
    //     caf:add_to_cart re-sync attaches fresh platform cookies.
    //   - Tee Buy Now redirects to /checkout via the SDK without form
    //     submit → teeinblue-event-after-cart-added capture-phase sync
    //     ensures UTM is on the cart before the SDK navigates away.
    //   - User closes tab / iOS Safari pagehide where beforeunload doesn't
    //     fire → pagehide + keepalive fetch gives one last sync attempt.

    // Bridge dispatches caf:add_to_cart after every successful /cart/add.js
    // (XHR + fetch patcher). Re-sync to refresh platform cookies that may
    // have been set by Meta Pixel / Google tag in the seconds since init.
    document.addEventListener('caf:add_to_cart', function () {
      syncFreshCartAttributes();
    });

    // TeeInBlue cart-added (regular path → mini-cart drawer, Buy Now path →
    // /checkout). Capture phase so we run before any bubble-phase Tee handler
    // opens UI or lets the SDK navigate the page.
    document.addEventListener(
      'teeinblue-event-after-cart-added',
      function () {
        syncFreshCartAttributes({ force: true });
      },
      true
    );

    // Final attempt on tab close / navigation away. keepalive: true on the
    // syncCartAttributes fetch lets the request complete after the page is
    // gone. pagehide is more reliable than beforeunload on mobile Safari.
    window.addEventListener('pagehide', function () {
      syncFreshCartAttributes();
    });
  }

  function bindBotBlockerConsentSync() {
    function syncIfConsentChanged() {
      var currentConsent = readBotBlockerConsent();
      if (currentConsent === lastBotBlockerConsent) return;
      lastBotBlockerConsent = currentConsent;
      syncFreshCartAttributes({ force: true });
    }

    window.addEventListener('bot-blocker:decision', syncIfConsentChanged);
    window.addEventListener('storage', function (event) {
      if (!event || event.key !== BOT_BLOCKER_CONSENT_KEY) return;
      syncIfConsentChanged();
    });
  }

  function attachSubmitInjection() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.getAttribute) return;
        if (!isPageAllowed()) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart') === -1 && action.indexOf('/checkout') === -1) return;
        // Rebuild at submit time so platform cookies (_fbp set late by Meta
        // Pixel, _ga, _gcl_au) reflect the freshest values right before
        // checkout handoff.
        var freshAttrs = buildAttributes();
        injectAttributesIntoForm(form, freshAttrs);
        if (form.querySelector('[data-cart-checkout-button], [name="checkout"]')) {
          syncCartAttributes(freshAttrs, { force: true });
        }
      },
      true
    );
  }

  function publishShopifyCustomerEvent(payload) {
    if (!payload) return;
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;

    try {
      window.Shopify.analytics.publish('caf_attribution_ready', {
        caf_attribution: payload
      });
    } catch (error) {
      // Ignore analytics publish errors; cart attributes remain the checkout handoff.
    }
  }

  function pushAttributionToDataLayer(payload) {
    if (!payload) return;
    window.cafAttribution = payload;
    if (!isTrackingAllowed()) return;
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'caf_attribution_ready',
        caf_attribution: payload
      });
    }
    publishShopifyCustomerEvent(payload);
  }

  var queryParams = parseQueryParams();
  var storedPayload = readAttributionPayload();
  var updatedPayload = updateAttributionFromUrl(storedPayload, queryParams);
  if (updatedPayload) {
    writeAttributionPayload(updatedPayload);
  }

  runWhenPageAllowed(function () {
    syncFreshCartAttributes();
  });

  runWhenTrackingAllowed(function () {
    pushAttributionToDataLayer(updatedPayload);
    scheduleKlaviyoUtmIdentify(updatedPayload);
  });

  // Meta Pixel sets _fbp/_fbc and Google tag sets _ga/_gcl_au asynchronously
  // — usually within the first 1–2s. Re-sync once the tags have had time to
  // run so the cart carries the freshest browser identifiers. Signature
  // dedup short-circuits the fetch when nothing new is captured.
  window.setTimeout(function () {
    syncFreshCartAttributes();
  }, 3000);

  attachSubmitInjection();
  bindBotBlockerConsentSync();
  bindCartLifecycleSync();
})();
